import { TableHead, TableCell, Checkbox, Typography } from '@mui/material';

interface HeadCell {
    id: string;
    label: string;
}

const headCells: readonly HeadCell[] = [
    {
        id: 'data.fullName',
        label: 'Contact',
    },
    {
        id: 'data.occupationTitle',
        label: 'Job title',
    },
    {
        id: 'data.organizationName',
        label: 'Company',
    },
    {
        id: 'data.industry',
        label: 'Industry',
    },
    {
        id: 'data.companySize',
        label: 'Company size',
    },
    {
        id: 'data.location',
        label: 'Location',
    },
];

interface TableHeaderProps {
    numSelected: number;
    onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
    rowCount: number;
}

export const TableHeader = (props: TableHeaderProps) => {
    const { onSelectAllClick, numSelected, rowCount } = props;

    return (
        <TableHead
            sx={{
                borderRadius: '14px',
                border: '1px solid var(--grey-palette-grey-3, #E4E6EB)',
                background: 'var(--grey-palette-grey-1, #F7F8FA)',
                width: '100%',
            }}
        >
            <TableCell>
                <Checkbox
                    color="primary"
                    indeterminate={numSelected > 0 && numSelected < rowCount}
                    checked={rowCount > 0 && numSelected === rowCount}
                    onChange={onSelectAllClick}
                    sx={{
                        '& .MuiSvgIcon-root': {
                            fontSize: 24,
                        },
                    }}
                />
            </TableCell>
            {headCells.map((headCell, i) => (
                <TableCell
                    key={headCell.id}
                    align={'left'}
                    sx={{
                        paddingLeft: 0,
                        paddingRight: '8px',
                    }}
                >
                    <Typography
                        sx={{
                            whiteSpace: 'nowrap',
                            color: 'var(--grey-palette-grey-5, #6B7985)',
                            fontSize: '14px',
                            fontStyle: 'normal',
                            fontWeight: 400,
                            lineHeight: '21px /* 150% */',
                        }}
                    >
                        {headCell.label}
                    </Typography>
                </TableCell>
            ))}
        </TableHead>
    );
};
